import i18n from "../../../i18n";
import lodash from "lodash";
import { conditionFormChecker, putField } from "../../../utils/form";
import { createFieldSelect } from "../../../components/input/template-builder/template-builder.logic";
import { callUserReport } from "./report.logic";

export const createFields = ({ props, data, key }) => {
    const { useForm } = data
    const { modelRef } = useForm
    const model = key ? lodash.get(modelRef, key) : modelRef
    const prefix = key ? `${key}.` : ''
    return putField({
        data, fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refUserReport`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => `${i18n.global.t("model.report.title")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refUserReport,
                            "onUpdate:value": (value) => {
                                model.refUserReport = value;
                                model.refReport = value ? value.refReport : null;
                            },
                            disabled: false,
                            list: ({ searchQuery }) => callUserReport({ props, searchQuery, data }),
                            renderLabel: ({ item }) => (<h3>{item?.refReport?.seq} {item?.refReport?.title}</h3>)
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
        ]
    })
}